/* eslint-disable import/no-import-module-exports */
import { PAGE_CHANGE_MESSAGE_BUS_TOPIC, BEFORE_PAGE_CHANGE_MESSAGE_BUS_TOPIC } from '../../universal/app/constants';
import { components } from '../../universal/common/constants';
import { checkSeoBoxDataExistence } from '../../universal/common/utils';

import AppManager from './manager';
import { getSeoData } from './utils';
import { getSeoServiceConfig } from './bridge';

const {
    locale, platform, seoData, subFeatureData,
} = getSeoServiceConfig();

const manager = new AppManager({ locale, platform });

const updateSeoBox = (data) => {
    if (checkSeoBoxDataExistence(data)) {
        manager.show(components.SEO_BOX, data);
    } else {
        manager.hide(components.SEO_BOX);
    }
};

const updateSubFeature = (data) => {
    if (data && data.length) {
        manager.show(components.SUB_FEATURE, data);
    } else {
        manager.hide(components.SUB_FEATURE);
    }
};

updateSeoBox(seoData);
updateSubFeature(subFeatureData);

window.WH.messageBus.subscribe(PAGE_CHANGE_MESSAGE_BUS_TOPIC, async () => {
    try {
        const data = await getSeoData();
        const { seoData: newSeoData, subFeatureData: newSubFeatureData } = await data.json();

        updateSeoBox(Object.assign(newSeoData || {}, { timeStamp: Date.now() }));
        updateSubFeature(newSubFeatureData);
    } catch (err) {
        manager.hide(components.SEO_BOX);
        manager.hide(components.SUB_FEATURE);
    }
});

window.WH.messageBus.subscribe(BEFORE_PAGE_CHANGE_MESSAGE_BUS_TOPIC, () => {
    manager.hide(components.SEO_BOX);
    manager.hide(components.SUB_FEATURE);
});

if (module.hot) {
    module.hot.accept();
}
/* eslint-enable import/no-import-module-exports */
